export default __webpack_public_path__ + "static/media/logout.f8ac3093.svg";